import { hasFieldChangedValue, validateEmail } from '../../../../Helpers/FormInputHelper';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';

export const getChangedFieldsForEmployer = (editedEmployer, employer) => {
  let sum = 0;

  if (hasFieldChangedValue(editedEmployer?.name, employer.name)) {
    sum = sum + 1;
  }
  if (hasFieldChangedValue(editedEmployer?.mobile, employer.mobile)) {
    sum = sum + 2;
  }
  if (hasFieldChangedValue(editedEmployer?.phone, employer.phone)) {
    sum = sum + 4;
  }
  if (hasFieldChangedValue(editedEmployer?.email, employer.email)) {
    sum = sum + 8;
  }
  // address is 16, but it is updated in separate modal
  if (hasFieldChangedValue(editedEmployer?.country?.code, employer?.country?.code)) {
    sum = sum + 32;
  }
  return sum;
};

export const areFieldsValid = editedEmployer => {
  const errors = [];

  if (!editedEmployer.name || editedEmployer.name?.trim() === '') {
    errors.push({});
  }

  if (!editedEmployer.country) {
    errors.push({});
  }

  if (!!editedEmployer.email && !validateEmail(editedEmployer.email)) {
    errors.push({
      inputId: 'email',
      message: formatMessage(Messages.common_incorrectEmailFormat),
    });
  }

  return errors;
};
